<template>
  <div>
    <el-breadcrumb separator=">" class="bc-nav">
      <el-breadcrumb-item :to="{ path: '/companyInfo' }">
        <i class="iconfont icon_home icon-t-1"></i>
        <span>公司</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/role' }">角色权限管理</el-breadcrumb-item>
      <el-breadcrumb-item>角色权限设置</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="segment-outer">
      <div class="segment">
        <div class="segment-header">角色名称</div>
        <div class="segment-area pt-20 pb-20" id="auto-0">
          <el-row>
            <el-col :span="24">
              <div v-if="type == 'roleAdd'">
                <el-input
                  style="width: 400px"
                  v-model.trim="roleName"
                  :maxlength="32"
                  auto-complete="off"
                  placeholder="请输入新建角色名称"
                ></el-input>
              </div>
              <div v-if="type == 'roleEdit'">
                {{ roleName }}
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="segment-outer">
      <div class="segment mt-10">
        <div class="segment-header">权限设置</div>
        <div class="segment-area pt-20 pb-20">
          <div class="plr-28" id="auto-1">
            <el-tree
              :data="allRole"
              ref="tree"
              show-checkbox
              node-key="powerCode"
              :props="defaultProps"
              :default-expand-all="true"
            ></el-tree>
          </div>
        </div>
        <div class="segment-foot">
          <el-button type="primary" size="small" @click="submit" id="auto-2">保存</el-button>
          <el-button size="small" @click="cancel" id="auto-3">取消</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 自动化测试id
 * 当前最大值为:3
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import axios from '@/api/axiosNew';
import api from '@/api/base.new.api';
export default {
  data() {
    return {
      allRole: [],
      defaultProps: {
        children: 'children',
        label: 'powerName'
      },
      roleName: '',
      roleCode: '',
      type: 'roleAdd'
    };
  },
  created() {
    this.roleCode = this.$route.params.key || '';
    this.roleName = this.$route.params.name || '';
    this.type = this.roleCode ? 'roleEdit' : 'roleAdd';
    this.init();
  },
  methods: {
    async init() {
      await this.getAllRole();
      if (this.type == 'roleEdit') this.getRoleDetail();
    },
    async getAllRole() {
      return new Promise((resolve, reject) => {
        axios.post(api.findGlobalPermissionList).then(res => {
          this.allRole = res.data;
          resolve();
        });
      });
    },
    getRoleDetail() {
      axios.post(api.findRolePermissionList, { roleCode: this.roleCode }).then(res => {
        let powerCodes = res.data.map(el => el.powerCode);
        this.$refs.tree.setCheckedKeys(powerCodes);
      });
    },
    submit() {
      let url = this.type == 'roleAdd' ? api.createRole : api.updateRole;
      if (!this.roleName) {
        this.$message.error('角色名称不能为空');
        return;
      }
      var powerCodes = this.$refs.tree.getCheckedKeys();
      if (powerCodes.length == 0) {
        this.$message.error('至少勾选一项权限');
        return;
      }
      let postData = { roleName: this.roleName, powerCodes };
      if (this.type == 'roleEdit') postData.roleCode = this.roleCode;
      axios.post(url, postData).then(res => {
        this.$message.success('成功');
        this.$router.go(-1);
      });
    },
    cancel() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.plr-28 {
  padding: 0 28px;
}
.el-tree {
  border: none;
}
</style>
